// Author Lin
// Date 2023-04-20 15:48:02

import * as model from "@/model/sithMes/prd/SithMesPrdRoutingMaintainModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdRoutingMaintain(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
        callbackApi: process.env.VUE_APP_SITHMES_PRD_URL + '/sithMesPrdRoutingMaintain/workflow/complete-feedback',
        processDefinitionKey: "prd_route_maintain",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
